import { ProgressBar } from 'components/common';
import { useReduxState } from 'hooks';

interface Props {
  children: React.ReactNode;
  numberOfAnswers: number;
  numberOfAnsweredSubmissions: number;
}

const CalendarEventFeedbackQuestionOption = ({
  children,
  numberOfAnswers,
  numberOfAnsweredSubmissions
}: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="option">
      <div className="option-content">{children}</div>

      <div className="option-progress">
        <ProgressBar
          color={theme.chartMainColor}
          progress={numberOfAnswers / numberOfAnsweredSubmissions}
          progressStyle={{ height: 6 }}
        />
      </div>

      <div className="option-value">
        {`${Math.round(
          (numberOfAnswers / numberOfAnsweredSubmissions) * 100
        )}% (${numberOfAnswers})`}
      </div>

      <style jsx>{`
        .option {
          align-items: flex-start;
          background-color: ${theme.lightGreyLighter};
          border-radius: ${theme.cardBorderRadius};
          display: flex;
          gap: 15px;
          padding: 10px 15px;
        }
        .option:not(:first-child) {
          margin-top: 10px;
        }
        .option-content {
          color: ${theme.textColor};
          flex-grow: 1;
          flex-shrink: 1;
          font-size: 1.4rem;
          margin-right: 25px;
          padding: 1px 0;
          word-break: break-word;
        }
        .option-progress {
          flex-grow: 0;
          flex-shrink: 0;
          padding: 3px 0;
          width: 200px;
        }
        .option-value {
          color: ${theme.textColor};
          flex-grow: 0;
          flex-shrink: 0;
          font-size: 1.4rem;
          font-weight: 600;
          min-width: 60px;
          text-align: right;
        }
      `}</style>
    </div>
  );
};

export default CalendarEventFeedbackQuestionOption;
